<template>
	<div style="margin-left:50px">
	  <div class="subTop1">
	    <em>Policy Planning</em>
	    <span>政策法规</span>
	    <router-link to="/zhengce" class="more" @click.native="$track([['pagetype','首页-政策法规-更多-点击']])">更多</router-link>
	  </div>
	  <ul class="newsWap">
			<li v-for="(item,index) in zhengceList.data" v-if="index<5">
				<a @click="jumppush('/detail/'+item.id)" :title="item.title">{{item.title}}</a>
			</li>
	    <!-- <li><a href="##">自然资源部关于促进智能网联汽车发展维护测绘地理</a></li>
	    <li><a href="##">国家网信办发布《数据出境安全评估申报指南》</a></li>
	    <li><a href="##">安徽33条政策支持新能源汽车和智能网联汽车产业</a></li>
	    <li><a href="##">《信息通信行业绿色低碳发展行动计划》解读</a></li>
	    <li><a href="##">七部门：2025年信息通信业绿色低碳发展管理机制</a></li> -->
	  </ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				zhengceList: [],
			}
		},
		created:function(){
			this.zhengcefnc();
		},
		computed: {
	
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			zhengcefnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'szjj/searchArticles',
						responseType: 'json',
						params: {
							columnID: 'e826806f46294fd494cc35990a8698fa',
							// isTopArticle: '1',
							iPage:'1',
							pageSize:'5',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.zhengceList = response.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		}
	}
</script>

<style>
</style>
